function sortBarChartData(data) {
  if (data.length === 0) {
    return [];
  }
  const labels = data[0].data.map(({
    key
  }) => key);
  return labels.map((_, index) => {
    return data.map(type => {
      var _type$data$index;
      const value = (_type$data$index = type.data[index]) === null || _type$data$index === void 0 ? void 0 : _type$data$index.value;
      if (value !== null && isNaN(Number(value))) {
        return null;
      }
      return value;
    });
  });
}

export { sortBarChartData };
